import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { getRouteUrl, routeConfigs } from '../common/constants/route.config';
import { VisitorApiService } from '../services/visitor.api.service';

@Injectable()
export class EventGuard implements CanActivate {
    public hubName: string;

    constructor(private router: Router,
                private visitorApiService: VisitorApiService) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // if (state.url && state.url.indexOf('/') !== -1) {
        //     let urlSegments = state.url.split('/');
        //     if (urlSegments.length > 1) {
        //         let hubName = urlSegments[1];
        //
        //         return this.visitorApiService.getToggles(hubName).pipe(map(toggle => {
        //                 if (toggle && toggle.eventCalendar === false) {
        //                     this.router.navigateByUrl(getRouteUrl(routeConfigs.auth.login));
        //                     return false;
        //                 } else {
        //                     return true;
        //                 }
        //             }),
        //             catchError((err) => {
        //                 return Observable.of(true);
        //             }));
        //     } else {
        //         return Observable.of(true);
        //     }
        // } else {
        //     return Observable.of(true);
        // }
        return Observable.of(true);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/guards/event.guard.ts